import { render, staticRenderFns } from "./datos-club-senior.vue?vue&type=template&id=6e209ae6"
import script from "./datos-club-senior.vue?vue&type=script&lang=js"
export * from "./datos-club-senior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports